export const appStoreLink = 'https://apps.apple.com/us/app/fonts-keyboard-cool-fun-font/id1495659522?ls=1';
